import request from '@/utils/request2'

// 列表(主数据列表)
export function loadTobaccoInfoListDataApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportTobaccoInfoListDataApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveTobaccoInfoApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateTobaccoInfoStatusApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deleteTobaccoInfoApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewTobaccoInfoApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/view',
    method: 'post',
    data
  })
}

// 列表
export function listTobaccoInfoApi(data) {
  return request({
    url: 'tms-web/tobaccoInfo/list',
    method: 'post',
    data
  })
}
